import React, { useState, useEffect } from 'react';
import styles from './TemplateHero7.module.css';

const TemplateHero7 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Strictly following the established pattern)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Layer */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        >
          <div className={styles.overlay}></div>
        </div>
      ))}

      {/* The Floating Frame Decoration */}
      <div className={styles.frameDecoration}></div>

      {/* Content Center */}
      <div className={styles.contentWrapper}>
        <div className={styles.textContainer} key={`content-${currentSlide}`}>
          <div className={styles.overflowHidden}>
            <h2 className={styles.outlineTitle}>{slides[currentSlide].title}</h2>
          </div>
          
          <div className={styles.overflowHidden}>
            <h1 className={styles.mainTitle}>{slides[currentSlide].title}</h1>
          </div>
          
          <p className={styles.description}>
            {slides[currentSlide].subtitle}
          </p>

          <div className={styles.btnStack}>
            <button className={styles.exploreBtn}>
              Take the Tour
              <span className={styles.btnLine}></span>
            </button>
          </div>
        </div>
      </div>

      {/* Matrix Grid Indicators */}
      {slides.length > 1 && (
        <div className={styles.gridNav}>
          {slides.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.gridBox} ${index === currentSlide ? styles.activeBox : ''}`}
            >
              <span className={styles.boxLabel}>0{index + 1}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateHero7;